module.exports = __webpack_public_path__ + "media/images/img-realestate-10-572333a8.png";